<template>
  <div>
    <div class="login">
      <h3>Alpine Leasing Rental Application</h3>
      <img class="login-img" src="../assets/login.svg" alt="" />
      <div>
        <label>Email</label>
        <input class="input" type="text" v-model="email" />
        <label>Password</label>
        <input class="input" type="password" v-model="password" />
      </div>
      <button @click="login()">Submit</button>
    </div>
  </div>
</template>
<script>
import { auth } from "../assets/js/firebase.js";
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    login() {
      const vm = this;
      // eslint-disable-next-line no-useless-escape
      let isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        vm.email
      );
      if (!isValid) return alert("Enter valid email address");
      if (vm.password === "") return alert("Enter password");
      vm.$root.loader = true;
      auth
        .signInWithEmailAndPassword(vm.email, vm.password)
        .then(() => {
          vm.$root.loader = false;
          vm.email = "";
          vm.password = "";
          vm.$router.replace("/admin");
        })
        .catch(({ message }) => {
          vm.$root.loader = false;
          alert(message);
        });
    }
  }
};
</script>
<style>
body {
  background: #f1f1f1;
}
.login {
  width: 350px;
  box-shadow: 2px 2px 4px lightgrey;
  padding: 20px;
  height: 400px;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  margin: auto;
  background: white;
}
.login img {
  width: 150px;
  margin-top: 20px;
  height: 150px;
}
.login label {
  float: left;
  color: grey;
  margin-top: 20px;
  font-size: 14px;
  margin-bottom: 5px;
}
.input {
  width: 100%;
  font-size: 14px;
  height: 35px;
  background: white;
  outline: none;
  border: 1px solid lightgray;
  padding-left: 10px;
  border: 1px solid lightgray !important;
  outline: none !important;
  box-sizing: border-box;
}
.login-img {
  margin-top: 0px !important;
  height: 100px !important;
}
.login button {
  width: 100%;
  margin-top: 20px;
  cursor: pointer;
  height: 35px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1px;
  width: 100%;
  background-color: #6c63ff;
  border: none;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  min-width: 160px;
}
.btn-logout {
  width: 110px !important;
  float: left;
}
.btn-submit {
  width: 110px !important;
  float: right;
}
</style>
